import { Component } from '@angular/core';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';

@EnableClassTelemetry()
@Component({
  selector: 'app-progress-widget',
  templateUrl: './progress-widget.component.html',
  styleUrls: ['./progress-widget.component.scss'],
  standalone: false,
})
export class ProgressWidgetComponent {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
}
